import React from 'react';
import './common.css';
interface Props {
    show: boolean;
    onClick: () => void;
}
const backdrop = (props: Props) =>
    props.show ? (
        <div
            className="Backdrop"
            role="button"
            tabIndex={0}
            onKeyDown={props.onClick}
            onClick={props.onClick}
        ></div>
    ) : null;

export default backdrop;
